// Replace with react-router-dom-v5-compat/react-router-dom-v6
export const getSearchParams = search => new URLSearchParams(search)

export const encodeUrlParams = config => {
  const params = Object.keys(config)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(config[key])}`)
    .join('&')

  return params
}
